import { DatePicker } from "antd";
import dayjs from "dayjs";
import "moment/locale/zh-cn";
import "moment/locale/zh-tw";
import localeCN from "antd/es/date-picker/locale/zh_CN";
import localeTW from "antd/es/date-picker/locale/zh_TW";
import { useTranslation } from "@/langs/useTranslation";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const range = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};

export default ({ className, style, popupStyle, value, onChange }) => {
  const { userLanguage } = useTranslation();

  const locale =
    userLanguage === "zh_cn"
      ? localeCN
      : userLanguage === "zh_tw"
        ? localeTW
        : null;

  return (
    <DatePicker
      locale={locale}
      value={value}
      onChange={onChange}
      disabledDate={currentDate => {
        if (!currentDate) {
          return false;
        }
        // prettier-ignore
        const isBeforeYestoday = currentDate < dayjs().subtract(1, "d").startOf("d");
        const isAfterToday = currentDate > dayjs().endOf("d");
        return isBeforeYestoday || isAfterToday;
      }}
      disabledTime={date => {
        const nowHour = dayjs().hour();
        if (date && date.isBefore(dayjs().startOf("d"))) {
          return {
            disabledHours: () => range(0, nowHour)
          };
        }
        return {
          disabledHours: () => range(nowHour + 1, 24)
        };
      }}
      format="YYYY-MM-DD HH:00"
      showTime={{
        hideDisabledOptions: true
      }}
      showNow={false}
      className={className}
      style={style}
      popupStyle={{ zIndex: 1500, ...popupStyle }}
    />
  );
};
